<template>
<div class="switch-heading">
    <div class="checkbox-column" :title="checkboxName">
        <v-checkbox v-model="checkboxValue" :label="schema.label" class="compact" hide-details/>
    </div>
    <transition name="fade">
    <div v-if="checkboxValue"  style="margin-bottom:-10px;">

        <FormBlock
            ref="theInput"
            :horizontal="schema.horizontal"
            :schema="modifiedSchema" 
            :value="value"
            :context="context"
            @change="emitInputChange"
        />

    </div>
    </transition>
</div>

</template>

<script>
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import AlertHelpers from '../../helpers/AlertHelpers'
import draggable from 'vuedraggable'

export default {
    data() {
        return {
          
        }
    },

    components: {
        ConfirmIcon, draggable
    },
    
    props: {
        schema: Object,
        value: {
            type: Object,
            default: function() {
                return {}
            },
        },
        context: Object,
    },

    computed: {
        modifiedSchema() {
            const schema = Object.assign({}, this.schema)
            schema.type = this.schema.inputType
            schema.visible = true
            schema.label = this.schema.inputLabel || ''
            schema.compact = true
            return schema
        },

        checkboxName() {
            return this.schema.name + '_exists'
        },

        checkboxValue: {
            get() {
                return this.value[this.checkboxName] || false
            },
            set(newVal) {
                this.$set(this.value, this.checkboxName, newVal)
            }
        },
   
    },

    methods: {
        emitCheckboxChange(newVal) { 
            console.log('Section checkbox changes for switchheading', newVal)
            this.$emit('change', {
                type: 'Field Changed',
                field: this.schema.name + '_exists',
                value: newVal,
                changed: true,
            })
        },
        emitInputChange(newVal) { 
            console.log('Section input changes for switchheading', newVal)
            this.$emit('change', {
                type: 'Field Changed',
                field: this.schema.name,
                value: newVal,                
                changed: true,
            })
        },
    },

    created() {
        
    },

    watch: {
        'checkboxValue': {
            handler: function(newVal) {
                if(newVal) {
                    setTimeout( () => {
                        this.$refs.theInput.focusFirst()
                    },100)
                } else {
                    this.value[this.schema.name] = null 
                }
                this.emitCheckboxChange(newVal)
            }
        }
    }
}
</script>

<style scoped>  

.switch-heading {
    display:flex;
    flex-wrap:wrap;
}

.switch-heading > div {
    flex-grow: 1;
    min-width: 150px;
    flex-basis:50%

}
.switch-heading > div:first-child {
    flex-basis: 50%;
    padding-top:7px;
}


   
</style>



// WEBPACK FOOTER //
// SwitchHeadingControl.vue?04ca065e